import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switcher">
      <button
        className={`lang-btn ${i18n.language === 'tr' ? 'active' : ''}`}
        onClick={() => changeLanguage('tr')}
      >
        <span className="flag">🇹🇷</span>
        <span className="lang-code">TR</span>
      </button>
      <button
        className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
      >
        <span className="flag">🇬🇧</span>
        <span className="lang-code">EN</span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;